import { Component, Input, OnInit } from '@angular/core';
import { Router,NavigationStart } from '@angular/router';
import {LocalStorageService} from 'ngx-webstorage';
import { Location } from '@angular/common';
import { Subject, Observable } from "rxjs";

import {DataService, SharedService} from '../../services';
import { JwtService } from 'src/app/auth/services';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { LookupCategory } from 'src/app/shared/enums/EnumsVMS';
import { User} from '../../../auth/models';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  show: boolean = false;
  showUsers: boolean = true;
  userName: string;
  currentUser;
  role;
  userRole: any;
  profilePictureUrl: any;
  profileUserName: any;
  loggedInUserProfileId: any;
  isAdminMenuVisible: boolean = true;
  isAdmin:boolean=false;
  isVendorAdmin:boolean=false;
  isVendorUser:boolean = false;
  isVendorAccountUser:boolean = false;
  isUserMenuVisible:boolean = false;
  isSuperAdminVisible:boolean = false;
  isRateApporvalMenuVisible:boolean = false;
  lnkDashboard:any;
  rateApprovalUsersList: ILookupCategory[];
  loggedInUserProfile: User;
  firstName;
  lastName;
  fullName:any;
  @Input() resetFormSubject: Subject<boolean> = new Subject<boolean>();
  vendorOnboardProcessDocTemplateApprovalUsersList: ILookupCategory[];
  isVendorOnboardProcessSearchMenuVisible:boolean = false;

  constructor(private router:Router,
    private storage: LocalStorageService,
    private location: Location,
    private dataService: DataService,
    private jwtService:JwtService,
    public sharedService: SharedService
    ) {

      this.dataService.currentUserProfilePhoto.subscribe(profilePicture => this.profilePictureUrl = profilePicture);
      this.dataService.currentUserProfileName.subscribe(data => this.profileUserName = data);

     

      router.events.forEach((event) => {
        if (event instanceof NavigationStart) {
           if ((event['url'] == '/login') || (event['url'] == '/')|| (event['url'] == '/register')|| (event['url'] == '/register-profile')|| (event['url'] == '/forgot-password') || (event['url'] == '/users/new-user-change-password')) {
            this.show = false;
           console.log(event['url']);
           }
           else {
            setInterval(() =>  this.checkSessionTimeout(), 60000);           
             this.show = true;
             this.getLoggedInUserProfileId();
             this.checkRateApprovalUser();
             this.checkVendorOnboardProcessDocTemplateApprovalUser();
            //  this.profileUserName = 'superadmin';
            this.role = this.jwtService.getRoles();
            this.profileUserName = this.jwtService.gwtLoggedInUserProfileName();
            this.fullName = this.jwtService.getLoggedInUserFirstNameLastName();
            //console.log('name',this.fullName);
            this.firstName = this.fullName.firstName;
            this.lastName = this.fullName.lastName;
           }
          }
      });

    }

  ngOnInit(): void {
    this.checkRateApprovalUser();
    this.checkVendorOnboardProcessDocTemplateApprovalUser();
  }

  checkSessionTimeout()
  {
    var isTokenAvailable = this.sharedService.isTokenAvailable();
    if(isTokenAvailable){
      var result = this.sharedService.checkSessionTimeout();
     // console.log('Session' + result);
       if(!result) {
         localStorage.removeItem('VMS');
         localStorage.clear();
         this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate(['/login']);
      });
       }
    } 
    // else {
    //   localStorage.removeItem('VMS');
    //      this.router.navigateByUrl('/login');
    // }
  }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("User_View");
    if(!result)
    this.router.navigateByUrl('/login');
  }

  getLoggedInUserProfileId()
  {
    this.loggedInUserProfileId = this.sharedService.getLoggedInUserProfileId();
    if(this.loggedInUserProfileId <= 0 || this.loggedInUserProfileId == undefined|| this.loggedInUserProfileId == null)
    {
      /*console.log('this.loggedInUserProfileId');
      console.log(this.loggedInUserProfileId);*/
      this.show = false;
    }
    else{
      var loggedInUserRole = this.sharedService.getLoggedInUserRoles();
      
      if(loggedInUserRole == "Super Admin" || loggedInUserRole == "Admin" || loggedInUserRole == "VMS Analyst")
      {
        this.isAdminMenuVisible = true;
        this.lnkDashboard="/dashboard/admin";
      }else{
        this.isAdminMenuVisible = false;
        this.lnkDashboard="/dashboard/vendor";
      }

      if(loggedInUserRole=="Vendor Admin")
      {
        this.isVendorAdmin==true;
      }

      if(loggedInUserRole =="Vendor User")
      {
        this.isVendorUser = true;
      } else {
        this.isVendorUser = false;
      }

      if(loggedInUserRole == "Super Admin" || loggedInUserRole == "Admin" || loggedInUserRole == "Vendor Admin")
      {
        this.isUserMenuVisible = true;
      } else {
        this.isUserMenuVisible = false;
      }

      if(loggedInUserRole =="Super Admin")
      {
        this.isSuperAdminVisible = true;
      } else {
        this.isSuperAdminVisible = false;
      }
      //console.log('SuperAdmin', this.isSuperAdminVisible);
    }
    
  }

  onVendor() {
  }

  onLogout() {
    this.show = false;
    localStorage.removeItem('VMS');
    localStorage.clear();
    this.storage.clear(); 
    
      setTimeout(()=>{ 
        this.show = false;
      }, 200);

    
     // this.router.navigateByUrl('/login');

      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate(['/login']);
    });

  }

  checkRateApprovalUser() {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.RateApprovalUsers).subscribe((data: any) => {
    this.rateApprovalUsersList = data;
   //console.log(this.rateApprovalUsersList);
   // console.log(this.rateApprovalUsersList.description.indexOf(this.loggedInUserProfile.sub));
    var tmprateApprovalUsers = this.rateApprovalUsersList.findIndex(t=>t.description==this.loggedInUserProfile.sub);
  
   
  // console.log(tmprateApprovalUsers);
  // console.log(this.loggedInUserProfile.sub);
    if(tmprateApprovalUsers<0) {
      this.isRateApporvalMenuVisible = false;
    } else {
      this.isRateApporvalMenuVisible = true;
    }
    
  });
  }

  checkVendorOnboardProcessDocTemplateApprovalUser() {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.VendorOnboardProcessDocTemplateApproveUsers).subscribe((data: any) => {
    this.vendorOnboardProcessDocTemplateApprovalUsersList = data;
    //console.log(this.vendorOnboardProcessDocTemplateApprovalUsersList);
    //console.log(this.vendorOnboardProcessDocTemplateApprovalUsersList.description.indexOf(this.loggedInUserProfile.sub));
    var tmpVendorOnboardDocTemplateApprovalUsers = this.vendorOnboardProcessDocTemplateApprovalUsersList.findIndex(t=>t.description==this.loggedInUserProfile.sub);
    //console.log(tmpVendorOnboardDocTemplateApprovalUsers);
    //console.log(this.loggedInUserProfile.sub);
    if(tmpVendorOnboardDocTemplateApprovalUsers<0) {
      this.isVendorOnboardProcessSearchMenuVisible = false;
    } else {
      this.isVendorOnboardProcessSearchMenuVisible = true;
    }
    
  });
  }

}
